<div class="light-v2">
	<embed-preview class="contents"
		[form]="form"
		[channel]='channel'
		[theme]="'light-v2'"
		[configuration]="{
			standAlone: true, 
			autoPlay: false,
			showVideo: false}"
		[isActive]="isActive">
	</embed-preview>
</div>
